const PluginManager = window.PluginManager;

PluginManager.register(
    'showHighlightProductPlugin',
    () => import('./show-highlight-product-plugin/show-highlight-product-plugin.plugin'),
    '[data-product]',
);
PluginManager.register(
    'closeHighlightProductPlugin',
    () => import('./close-highlight-product-plugin/close-highlight-product-plugin.plugin'),
    '.cms-ambience-image-product .close-button',
);
